export default __webpack_public_path__ + "static/media/travel-companion.963f3a1b.png";